import utils from 'helpers/utils';
import logger from 'helpers/logger';
import ServiceStore from 'stores/service.store';
import constants from 'helpers/constants';

const path = utils.servicePath(import.meta.url);

export class CollectionStatService extends ServiceStore {
  constructor (app, callbacks) {
    logger.trace(`Starting module at: services/${path}`);

    super(path, app, {
      key: 'statId',
      refreshEnabled: false,
      invalidateFromParent: true,
      priority: [],
      watch: (entity, local) => {
        return (entity === 'entity' && local) ||
          ['comment', 'collection', 'tagGroup', 'question', 'customField'].includes(entity);
      },
      match: () => {
        // match all watches, invalidates on all changes
        return true;
      },
      process: (data, meta) => {
        // process
        if (meta?.context?.$store?.dataType === constants.dataTypes.list) {
          return data ? Object.keys(data).reduce((a, k) => {
            const statId = `${k}_${utils.sha1(meta?.dataKey.keys)}`;
            return a.concat([{statId, data: data[k]}]);
          }, []) : null;
        } else {
          const statId = `${meta.context?.$store.statId}_${utils.sha1(meta?.dataKey.keys)}`;
          return data ? {
            statId,
            data: (!data.hasOwnProperty('total') && data.hasOwnProperty(meta.context?.$store.statId)) ?
              data[meta.context?.$store.statId] : data
          } : null
        }
      }
    }, callbacks);
  }
}
